<template>
        <v-container
        fluid
        style="padding:0;"
        id="contact"
      >
        <v-container style="padding-top:5vh;padding-bottom:5vh">
          <v-row justify="center" align="center" class="center">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <p
                style="line-height:1.25"
                class="text-h4 text-sm-h4 text-md-h4 text-lg-h3 text-xl-h3 black--text font-weight-medium"
              >
                Let's Talk!
              </p>

              <p
                style="line-height:1.25"
                class="text-h5 text-sm-h5 text-md-h5 text-lg-h4 text-xl-h4  black--text font-weight-thin"
              >
                We are always just a text away.
              </p>
            </v-col>

            <v-col cols="12">
              <v-text-field v-model="name" label="Name" filled shaped />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="contact"
                label="Contact Information (Email / Phone)"
                filled
                shaped
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="message"
                label="Message"
                rows="4"
                auto-grow
                filled
                shaped
              />
            </v-col>

            <v-col cols="12" class="right">
              <!-- <v-btn text outlined color="#00bbe3">
                <v-icon>mdi-email</v-icon>
                <span style="padding-left:1vw">Email</span>
              </v-btn> -->

              <v-btn
                text
                outlined
                raised
                @click="sendWhatsapp()"
                color="green"
                style="margin-left:2vw"
              >
                <v-icon>mdi-whatsapp</v-icon>
                <span style="padding-left:1vw">Whatsapp</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Contact",
  data: () => ({
    name: "",
    contact: "",
    message: "",
  }),

};
</script>

<style scoped>

.workSansLight{
  font-family: 'Work Sans', sans-serif !important;font-weight:400;font-style: normal;
}

.workSans{
  font-family: 'Work Sans', sans-serif !important;font-weight:700;font-style: normal;
}

.playFair{
  font-family: 'Playfair Display', serif !important;font-weight:700; font-style:italic;
}

</style>
